export default class Dropdown {
    constructor(props = {}) {
        this.props = props;

        this.TIMER_TRIGGER = 250;

        this.isOpen = false;

        // ES6 Rebind
        this.onTriggerTouchDown = this.onTriggerTouchDown.bind(this);

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindMobileEvents();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.wrapper = this.props.el;
        this.ui.target = this.props.el.querySelector('.js-dropdown-target');
        this.ui.trigger = this.props.el.querySelector('.js-dropdown-trigger');
        this.ui.triggerClose = this.props.el.querySelectorAll('.js-dropdown-trigger-close');

        // Getting
        this.ui.lastTargetItem = this.ui.target.querySelectorAll('a')[this.ui.target.querySelectorAll('a').length - 1];
    }

    bindMobileEvents() {
        // Mobile touch
        this.ui.trigger.addEventListener('touchstart', this.onTriggerTouchDown);
    }

    unbindMobileEvents() {
        // Mobile touch
        this.ui.trigger.removeEventListener('touchstart', this.onTriggerTouchDown);
    }

    bindEvents() {
        this.ui.trigger.addEventListener('mouseenter', this.onTriggerMouseEnter.bind(this));
        this.ui.trigger.addEventListener('mouseleave', this.onTriggerMouseLeave.bind(this));

        this.ui.target.addEventListener('mouseenter', this.onTargetMouseEnter.bind(this));
        this.ui.target.addEventListener('mouseleave', this.onTargetMouseLeave.bind(this));

        // Focus / Blur logics
        this.ui.trigger.addEventListener('focus', this.onTriggerMouseEnter.bind(this));
        this.ui.target.addEventListener('focus', this.onTargetMouseEnter.bind(this));
        this.ui.lastTargetItem.addEventListener('blur', this.onLastTargetItemBlur.bind(this));

        [].forEach.call( this.ui.triggerClose, (item) => {
            item.addEventListener('click', this.closeTarget.bind(this));
        });
    }

    onTriggerMouseEnter() {
        if (this.isTarget) {
            clearTimeout(this.enterTimeout);

            this.enterTimeout = setTimeout(() => {
                clearTimeout(this.triggerTimeout);

                this.openTarget();
            }, this.TIMER_TRIGGER - 50);
        }
    }

    onTriggerMouseLeave() {
        clearTimeout(this.enterTimeout);

        this.triggerTimeout = setTimeout(() => {
            this.closeTarget();
        }, this.TIMER_TRIGGER);
    }

    onTargetMouseEnter() {
        this.isTarget = true;
        clearTimeout(this.triggerTimeout);

        this.openTarget();
    }

    onTargetMouseLeave() {
        this.closeTarget();
    }

    onTriggerTouchDown(e) {
        e.preventDefault();

        const currentTarget = e.currentTarget;

        if (!this.isOpen) {
            this.openTarget();
        } else {
            this.closeTarget();
        }
    }

    onLastTargetItemBlur() {
        this.closeTarget();
    }

    openTarget() {
        this.isOpen = true;

        this.ui.target.classList.add('is-visible');
    }

    closeTarget() {
        this.isOpen = false;

        this.ui.target.classList.remove('is-visible');
    }
}
